import { ILink } from '@models/ILink';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface Props {
  readonly link?: ILink | null;
  readonly linkCondition?: boolean;
  readonly hasHoverUnderline?: boolean;
  readonly className?: string;
  readonly onLinkClick?: () => void;
}

const ConditionalLinkWrapper = ({
  link,
  linkCondition = true,
  hasHoverUnderline,
  className,
  onLinkClick,
  children,
}: PropsWithChildren<Props>) =>
  link?.url && linkCondition ? (
    <a
      href={link.url}
      target={link.target}
      onClick={onLinkClick}
      className={classNames(
        {
          'decoration-1 underline-offset-2 hover:underline': hasHoverUnderline,
        },
        className
      )}
    >
      {children}
    </a>
  ) : (
    <>{children}</>
  );

export default ConditionalLinkWrapper;
